import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
const _ = require('lodash');
import * as $ from 'jquery';

import { SeedCropLossAddProductSliderModelService } from '../seed-crop-loss-add-product/seed-crop-loss-add-product-slider-model.service';
import { CommonService } from './../../../../services/common/common.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { SeedCropLossService } from '../../../../services/seed/seed-crop-loss/seed-crop-loss.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';
import { DashboardFilter } from './../../../../models/DashboardFilter';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { ViewportScroller } from '@angular/common';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-seed-crop-loss-request-entry',
  templateUrl: './seed-crop-loss-request-entry.component.html',
  styleUrls: ['./seed-crop-loss-request-entry.component.scss']
})
export class SeedCropLossRequestEntryComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('failedPaginator', { read: MatPaginator }) failedPaginator: MatPaginator;
  subscription = new Subscription();
  masterConstants = MasterConstants;
  dashboardFilter: DashboardFilter;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  requestHeaderId = 0;
  webOrderNumber: any;
  isEditMode = false;
  breadcrumbtext: string;
  soldToAccount: number;
  soldToDataLoading: any;
  soldToAccountList: any[];
  shipToAccountList: any[];
  shipToAccount: number;
  shipToAccountName: number;
  shipToDataLoading: any;
  readOnlyAccess = false;
  creditToList: any[];
  creditToAccount: number;
  creditToDataLoading: any;
  creditToAnotherLocation = false;
  growerList: any;
  growerGMK: number;
  growerLoading: any;
  requestedBy: string;
  requestOnBehalfList: any = [];
  emailAddress: string;
  isNotValid = false;
  isAddProductEnable = false;
  isReviewRequestEnable = false;
  isSaveOrderDraftEnable = false;
  productItemsDataSource: any;
  originalProductItemsDataSource: any;
  displayedColumns: string[] = ['checkbox', 'product', 'lotNumber', 'eligibleUnits', 'unitsSoldToGrower', 'failedUnits', 'uom', 'problemDescription'];
  errorMsgs = new Array();
  tabNode: string;
  searchCount = 0;
  currentErrorRow = 1;
  showErrorBlock = false;
  isAllProductChecked = false;
  showTabs = false;
  checkBoxCount = 0;
  disablecheckbox = true;
  // minDate: Date;
  // maxDate: Date = new Date();
  index: any;
  nextErrorId = 0;
  nextLotNumber: string;
  currentRequestedUser: string;
  effectiveConfigData: any;
  growerSliderSubscription: any;
  isSliderAddGrowerSet = false;
  selectedAccountObj: any;
  vendersArr: Array<string> = ['BAYER', 'CORTEVA', 'BASF', 'SYNGENTA'];
  isGrowerChange = false;
  isReview = false;
  isCustomerServiceRetailerEntryEffectiveDateAccess = false;
  isTraverseAllFailedProductsForValidations = false;
  treatmentList: any = [];
  adminConfigMessageList: any;
  isShowNonSubEmail = true;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;

  constructor(
    private seedCropLossAddProductSliderModelService: SeedCropLossAddProductSliderModelService,
    private router: Router,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private seedCropLossService: SeedCropLossService,
    private localStorageService: LocalStorageService,
    private sliderModelService: SliderModelService,
    private toastrService: ToastrService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private scroller: ViewportScroller
  ) {
    this.dashboardFilter = new DashboardFilter();
  }

  ngOnInit(): void {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    // if (this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR)) {
    //  let activeCropYear = JSON.parse(this.localStorageService.get(MasterConstants.ACTIVE_CROP_YEAR));
    //  this.minDate = new Date(activeCropYear.startDate);
    //  //this.maxDate = new Date(activeCropYear.endDate);
    // }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isShowNonSubEmail = false;
        } else {
          this.isShowNonSubEmail = true;
        }

        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_REPLANT);
        this.isCustomerServiceRetailerEntryEffectiveDateAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SEED_REPLANT_RETAILER_ENTRY_EFFECTIVE_DATE, MasterConstants.USER_ACCESS.EDIT_FULL);

        this.subscription.add(this.activatedRoute.params.subscribe(x => {
          this.errorMsgs = [];
          if (x['requestId']) {
            let isApprover = 0;
            if (x['isApprover']) {
              isApprover = x['isApprover'];
            }
            this.requestHeaderId = +x['requestId'];
            this.seedCropLossService.setRequestHeaderId(this.requestHeaderId);
            this.isEditMode = true;
            this.isAddProductEnable = true;
            this.enableReviewRequesAndSaveOrderDraft();
            this.getOrderDetails(isApprover);
          }
          else {
            this.isEditMode = false;
            this.setBreadcrumbText();
            this.loadMasterData();
          }
        }));
      }
    }

    this.productItemsDataSource = new MatTableDataSource([]);
    this.originalProductItemsDataSource = this.productItemsDataSource.data;

    this.subscription.add(this.seedCropLossAddProductSliderModelService.addModelData.subscribe(selectedProductList => {
      if (selectedProductList.length > 0) {
        this.formatNewAddedData(selectedProductList);
        this.enableReviewRequesAndSaveOrderDraft();
      }
    }));

    this.growerSliderSubscription = this.sliderModelService.gmkValue.subscribe(x => {
      this.isSliderAddGrowerSet = true;
      this.growerGMK = +x;
      this.getGrowerListByAccount();
      this.isAddProductEnable = true;
    }, error => { LolLoggerService.error(error); });

    this.seedCropLossService.getAdminConfigMessageList().subscribe((result: any[]) => {
      if (result && result.length > 0) {
        this.adminConfigMessageList = result;
      }
    });
  }

  // Set page breadcrumb text
  setBreadcrumbText() {
    if (!this.isEditMode) {
      this.breadcrumbtext = 'Create Request';
    }
    else if (this.isEditMode) {
      this.breadcrumbtext = 'Edit ID [' + this.webOrderNumber + ']';
    }
  }

  // Formate Data from Add Product Slider Model
  formatNewAddedData(productList: any[]) {
    const orderList = [];
    let rowId = 0;
    this.productItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });
    let productAdded = true;
    const newItemNumbers: Array<string> = [];
    productList.forEach(item => {
      const duplicateData = orderList.find(y => y.itemId == item.itemId && y.lotNumber == item.lotNumber);
      item.lineErrors = { 'itemId': item.itemId, 'lotNumber': item.lotNumber, 'errors': [] };
      item.lineError = false;

      if (duplicateData == undefined) {
        item.unitsPurchased = 0;
        item.unitsFailed = 0;
        item.plantingDate = null;
        orderList.push(item);
        newItemNumbers.push(item.itemNumber);
        if (productAdded) {
          this.toastrService.info('Product Added');
          productAdded = false;
        }
      } else {
        this.toastrService.warning('Product and Lot # are already on the request');
      }
    });

    this.productItemsDataSource.data = orderList;
    this.productItemsDataSource.paginator = this.failedPaginator;
    this.productItemsDataSource.paginator.firstPage();
    this.originalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));

    this.fetchAndSetItemsLicense(newItemNumbers);

    if (this.productItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }
  }

  fetchAndSetItemsLicense(itemNumbers: Array<string>) {
    if (itemNumbers.length > 0) {
      this.loaderService.setLoaderStatus(true);
      const licensePostData = {
        ItemNumber: itemNumbers.join(','),
        Gmk: this.growerGMK
      };
      this.subscription.add(this.seedCropLossService.getItemsLicenseData(licensePostData).subscribe((result: any[]) => {
        this.setLicenseDataIntoGridRows(result, this.productItemsDataSource.data);
        this.setLicenseDataIntoGridRows(result, this.originalProductItemsDataSource);
        this.isGrowerChange = false;
        this.loaderService.setLoaderStatus(false);
      }, ((error) => {
        this.loaderService.setLoaderStatus(false);
      })));
    }
  }

  quantityTextChange(productItem: any, column: string) {
    if (this.showErrorBlock) {
      productItem = this.validateFormEntries(productItem);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCropLossUnitValue: oldProductLineValue[column], newCropLossUnitValue: productItem[column] });
    this.enableReviewRequesAndSaveOrderDraft();
  }

  unitChange(action: string, productItem: any, column: string) {
    productItem[column] = this.commonService.isNumber(productItem[column]) == true ? productItem[column] : 0;

    if (action == 'decrease') {
      const decValue = +productItem[column] - 1;
      if (decValue > 0) {
        productItem[column] = decValue;
      }
      else {
        productItem[column] = 1;
      }
    }
    else {
      productItem[column] = +productItem[column] + 1;
    }

    if (productItem.allowDecimal) {
      productItem[column] = (+productItem[column]).toFixed(this.commonService.countDecimals(+productItem[column]));
    }

    if (this.showErrorBlock) {
      productItem = this.validateFormEntries(productItem);
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.originalProductItemsDataSource)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldCropLossUnitValue: oldProductLineValue[column], newCropLossUnitValue: productItem[column] });
    this.enableReviewRequesAndSaveOrderDraft();
  }

  loadMasterData() {
    this.loaderService.setLoaderStatus(true);

    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.seedCropLossService.getShipToAccountDataList());
    forkJoinAPIs.push(this.seedCropLossService.getAccountUser(0));
    forkJoinAPIs.push(this.seedCropLossService.getEffectiveConfigData());
    forkJoinAPIs.push(this.seedCropLossService.getItemsTreatmentData());
    this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      this.shipToAccountList = result[0];
      this.requestOnBehalfList = result[1];
      this.effectiveConfigData = result[2];
      this.treatmentList = result[3];
      if (!this.isEditMode) {
        this.emailAddress = this.isShowNonSubEmail ? this.emailAddress : this.requestOnBehalfList[0].userEmail;
        this.requestedBy = this.requestOnBehalfList[0].userId;
        this.currentRequestedUser = this.requestOnBehalfList[0].userId;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  getShipTo(event) {
    if (event) {
      this.seedCropLossService.setSelectedAccountNo(this.shipToAccount);
      this.loaderService.setLoaderStatus(true);

      this.getUserList(event.parentNumber);
      // this.getGrowerListByAccount();

      this.creditToAccount = null;
      this.creditToAnotherLocation = false;
      this.growerGMK = null;
      this.isAddProductEnable = false;

      const forkJoinAPIs = [];
      forkJoinAPIs.push(this.seedCropLossService.getCreditToAccounts(event.accountNumber, event.parentNumber));
      forkJoinAPIs.push(this.seedCropLossService.getSoldTo(event.accountNumber));
      this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
        this.creditToList = result[0];
        this.soldToAccountList = [result[1]];
        this.soldToAccount = this.soldToAccountList[0].accountNumber;
        // this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));
      this.getGrowerListByAccount();
      this.shipToAccountName = event.accountName;
    } else {
      this.creditToList = null;
      this.creditToAccount = null;
      this.soldToAccountList = null;
      this.soldToAccount = null;
      this.isAddProductEnable = false;
      this.creditToAnotherLocation = false;
      this.growerList = null;
      this.growerGMK = null;
      this.searchCount = 0;

      if (this.currentRequestedUser) {
        const requestItem = this.requestOnBehalfList.filter(r => r.userId === this.currentRequestedUser);
        this.requestedBy = requestItem[0].userId;
        this.emailAddress = this.isShowNonSubEmail ? this.emailAddress : requestItem[0].userEmail;
      }
    }
    this.errorMsgs = new Array();
    this.showErrorBlock = false;
    this.productItemsDataSource.data = [];
    this.originalProductItemsDataSource = [];
    this.enableReviewRequesAndSaveOrderDraft();
  }

  getCreditTo($event) {
    if ($event) {
      this.creditToAccount = $event.accountNumber;
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
    } else {
      this.creditToAccount = null;
    }
    this.enableReviewRequesAndSaveOrderDraft();
  }

  UpdateCreditToSelection(isCreditToOptionChecked) {
    if (!isCreditToOptionChecked) {
      this.creditToAccount = null;
    }
  }

  hasHeaderInfoChanged(fieldName) {
    if (fieldName && this.shipToAccount && this.isEditMode) {
      switch (fieldName) {
        case 'Credit Account':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
          break;
        case 'Email Address':
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
          break;
      }

      this.enableReviewRequesAndSaveOrderDraft();
    }
  }

  enableReviewRequesAndSaveOrderDraft() {
    if (this.readOnlyAccess) {
      this.isSaveOrderDraftEnable = false;
      this.isReviewRequestEnable = false;
    }
    else {
      if (this.growerGMK && this.originalProductItemsDataSource && this.originalProductItemsDataSource.length > 0
        && (!this.isNotValid)) {
        this.isSaveOrderDraftEnable = true;
        this.isReviewRequestEnable = true;
      }
      else {
        this.isSaveOrderDraftEnable = false;
        this.isReviewRequestEnable = false;
      }
    }
  }

  getUserList(accountNumber) {
    this.subscription.add(this.seedCropLossService.getAccountUser(accountNumber).subscribe((result: any) => {
      if (result.length > 0) {
        this.requestOnBehalfList = result;
        if (this.currentRequestedUser) {
          const requestItem = this.requestOnBehalfList.filter(r => r.userId === this.currentRequestedUser);
          this.requestedBy = requestItem[0].userId;
          this.emailAddress = this.isShowNonSubEmail ? this.emailAddress : requestItem[0].userEmail;
        }
      }
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.emailAddress, true);
    if (this.isNotValid) {
      this.isSaveOrderDraftEnable = false;
      this.isReviewRequestEnable = false;
    }
    else {
      this.isSaveOrderDraftEnable = true;
      this.isReviewRequestEnable = true;
      this.enableReviewRequesAndSaveOrderDraft();
    }
  }

  setUserEmail(event) {
    if (event) {
      this.emailAddress = event.userEmail;
      this.requestedBy = event.userId;
    } else {
      this.emailAddress = null;
      this.requestedBy = null;
    }
    if (this.isEditMode) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
    }
    this.enableReviewRequesAndSaveOrderDraft();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  navigateToLandingPage() {
    this.router.navigate(['/crop-loss-landing']);
    this.commonService.currentTabIndex.next(1);
  }

  addProduct() {
    this.isReview = false;
    this.seedCropLossAddProductSliderModelService.activeSlider('AddSeedCropLossProductSlider');
  }

  growerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // Serach the data in list and get the serach items count
  search($event) {
    let list: any;
    list = _.filter(this.growerList, item => item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf($event) > -1
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf($event) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf($event) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf($event) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf($event) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf($event) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf($event) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf($event) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf($event) > -1));
    this.searchCount = list.length;
  }

  onGrowerSelection($event) {
    if ($event) {
      this.growerGMK = $event.gmk;
      this.isAddProductEnable = true;
      this.isGrowerChange = true;
      this.fetchAndSetItemsLicense(this.productItemsDataSource.data.map(x => x.itemNumber));
      if (this.isReview) {
        this.clearLicenseNumberError(this.productItemsDataSource, 'licenseNumberRequired');
      }
    }
    else {
      this.growerGMK = null;
      this.isAddProductEnable = false;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
    this.enableReviewRequesAndSaveOrderDraft();
  }

  clearLicenseNumberError(dataSource, errorId) {
    if (dataSource.data && dataSource.data.length > 0) {
      dataSource.data.forEach(productItem => {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== errorId);
        const index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      });
    }
  }

  openGrowerSliderModel() {
    if (this.shipToAccount && this.shipToAccount != 0) {
      this.sliderModelService.initializeComponentVal(this.shipToAccount);
      this.sliderModelService.toAccountNumber.next(this.shipToAccount);
      this.sliderModelService.growerSearchType.next('SCL');
      this.sliderModelService.activeSlider('growerSearchSlider');
    }
    else {
      this.toastrService.warning('Select an Account before adding a Grower.');
    }
  }

  getGrowerListByAccount() {
    this.growerLoading = true;
    this.dashboardFilter.cropYear = this.headerYear;
    this.dashboardFilter.shipToAccount = this.shipToAccount;
    const growerFilters = { 'GrowerGLN': '', 'GrowerName': '' };
    this.subscription.add(this.seedCropLossService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
      this.growerList = result;
      this.searchCount = this.growerList.length;
      this.growerList.forEach(grower => {
        grower.businessName = (grower.businessName == null || grower.businessName == '' ?
          (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
          (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
          (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
          : grower.businessName);
        // grower.OrderNumber = grower.growerOrderList[0] ? grower.growerOrderList[0].orderNumber : '';
        // grower.GrowerOrderID = grower.growerOrderList[0] ? grower.growerOrderList[0].GrowerOrderID : 0;
        // grower.ShipToAccount = grower.growerOrderList[0] ? grower.growerOrderList[0].ShipToAccount : this.shipToAccount;
        // grower.OrderStatus = grower.growerOrderList[0] ? grower.growerOrderList[0].OrderStatus : '';
        grower.EmailTo = this.emailAddress;
      });
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.growerLoading = false;
      this.loaderService.setLoaderStatus(false);
    }));
  }

  saveDraft(isReview: boolean = false) {
    this.isReview = isReview;
    $('#failedProductTbl').animate({ scrollTop: 0 }, 'slow');
    const isEntriesValid = isReview ? this.validateOrder() : true;
    if (isEntriesValid) {
      this.loaderService.setLoaderStatus(true);
      const postData = {
        IsUpdateRequest: this.isEditMode,
        RequestHeaderId: this.requestHeaderId,
        Gmk: this.growerGMK,
        ShipToAccount: this.shipToAccount,
        CompanyCode: this.headerCompany,
        CreditToAccountNumber: this.creditToAccount,
        RequestedBy: this.requestedBy,
        EmailAddress: this.emailAddress,
        FailedProductList: this.productItemsDataSource.data
      };

      postData.FailedProductList.forEach(x => {
        x.plantingDate = x.plantingDate ? (new Date(x.plantingDate)).toLocaleDateString('en-US').replace(/\u200E/g, '') : null;
      });

      this.subscription.add(this.seedCropLossService.saveCropLoss(postData).subscribe((result: any) => {
        if (result) {
          this.toastrService.success('Crop Loss saved successfully.');

          if (isReview) {
            const licenseManuallyEnteredFailedArr = result.failedProductList.map(x => x.licenseManuallyEntered);
            if (licenseManuallyEnteredFailedArr.find(x => x === 2) != null) {
              this.toastrService.error(
                'This Crop Loss Request will be saved as a Draft Request until the Grower License has been approved. Please check your Draft Request tab in 24 hours to ensure the License number has been approved. Then, you can submit the request for approval.');
              this.router.navigate(['/crop-loss-landing']);
            } else {
              this.seedCropLossService.setRequestHeaderId(result.requestHeaderId);
              this.router.navigate(['/crop-loss-review']);
            }
          } else {
            this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.failedProductList));
            this.router.navigate(['/crop-loss-landing']);
          }

          this.loaderService.setLoaderStatus(false);

          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
        this.isSaveOrderDraftEnable = true;
        this.isReviewRequestEnable = true;
        this.toastrService.error('Crop Loss not saved in the system.');
      }));
    }
  }

  // Validate line items
  validateOrder() {
    this.loaderService.setLoaderStatus(true);
    let isValidated = true;
    this.isTraverseAllFailedProductsForValidations = false;
    this.errorMsgs = [];
    if (this.productItemsDataSource.data && this.productItemsDataSource.data.length > 0) {
      isValidated = true;
      this.productItemsDataSource.data.forEach(x => {
        x = this.validateFormEntries(x);
        if (x.lineErrors.errors.length > 0) {
          isValidated = false;
        }
      });

      this.isTraverseAllFailedProductsForValidations = true;
    }
    this.loaderService.setLoaderStatus(false);
    return isValidated;
  }

  validateFormEntries(productItem) {
    if (!this.isCustomerServiceRetailerEntryEffectiveDateAccess) {
      const productConfigData = this.effectiveConfigData.find(x => x.productLineId === productItem.productLineId);
      if (productConfigData) {
        const currentDate = new Date();
        if (new Date(productConfigData.retailerEntryEffectiveFromDate) > currentDate ||
          new Date(productConfigData.retailerEntryEffectiveToDate) < currentDate) {
          if (!productItem.lineErrors.errors.find(x => x.id === 'retailerEntryEffectiveDate')) {
            productItem.lineErrors.errors.push({
              id: 'retailerEntryEffectiveDate',
              error: 'No longer accepting seed crop loss for this crop type'
            });
          }
        } else {
          productItem.lineErrors.errors =
            productItem.lineErrors.errors.filter(y => y.id !== 'retailerEntryEffectiveDate');
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
        }
      }
    }

    if (Number(productItem.unitsPurchased) < 0) {
      if (!productItem.lineErrors.errors.find(x => x.id == 'unitsSoldToGrowerEmptyQuantity')) {
        productItem.lineErrors.errors.push({ id: 'unitsSoldToGrowerEmptyQuantity', error: 'Please enter a positive number units sold to grower quantity' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'unitsSoldToGrowerEmptyQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (productItem.unitsPurchased == 0) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'unitsPurchasedRequired')) {
        productItem.lineErrors.errors.push({ id: 'unitsPurchasedRequired', error: 'Please enter units sold to grower' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'unitsPurchasedRequired');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (Number(productItem.unitsPurchased) > Number(productItem.eligibleUnits)) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'unitsPurchasedGreaterToEligibleUnits')) {
        productItem.lineErrors.errors.push({ id: 'unitsPurchasedGreaterToEligibleUnits', error: 'Eligible Units should be greater than or equal to Units Sold to Grower' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'unitsPurchasedGreaterToEligibleUnits');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (Number(productItem.unitsFailed) < 0) {
      if (!productItem.lineErrors.errors.find(x => x.id == 'failedUnitsEmptyQuantity')) {
        productItem.lineErrors.errors.push({ id: 'failedUnitsEmptyQuantity', error: 'Please enter a positive number failed units quantity' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'failedUnitsEmptyQuantity');
      var index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (productItem.unitsFailed == 0) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'unitsFailedRequired')) {
        productItem.lineErrors.errors.push({ id: 'unitsFailedRequired', error: 'Please enter failed units' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'unitsFailedRequired');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (Number(productItem.unitsFailed) > Number(productItem.eligibleUnits)) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'unitsFailedGreaterToEligibleUnits')) {
        productItem.lineErrors.errors.push({ id: 'unitsFailedGreaterToEligibleUnits', error: 'Eligible Units should be greater than or equal to Failed Units' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'unitsFailedGreaterToEligibleUnits');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (Number(productItem.unitsFailed) > Number(productItem.unitsPurchased)) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'unitsFailedGreaterToUnitsPurchased')) {
        productItem.lineErrors.errors.push({ id: 'unitsFailedGreaterToUnitsPurchased', error: 'Units Sold to Grower should be greater than or equal to Failed Units' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'unitsFailedGreaterToUnitsPurchased');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (!productItem.problemDescription || productItem.problemDescription.trim() === '') {
      if (!productItem.lineErrors.errors.find(x => x.id === 'problemDescription')) {
        productItem.lineErrors.errors.push({ id: 'problemDescription', error: 'Please explain crop lost description of problem' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'problemDescription');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (!productItem.growerInvoice || productItem.growerInvoice.trim() === '') {
      if (!productItem.lineErrors.errors.find(x => x.id === 'growerInvoice')) {
        productItem.lineErrors.errors.push({ id: 'growerInvoice', error: 'Please enter invoice number for  the crop loss entry' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'growerInvoice');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (!productItem.plantingDate) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'plantingDate')) {
        productItem.lineErrors.errors.push({ id: 'plantingDate', error: 'Please enter planting date' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'plantingDate');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (this.vendersArr.includes(productItem.vendorName)) {
      if (!productItem.licenseNumber || productItem.licenseNumber.trim() === '') {
        if (!productItem.lineErrors.errors.find(x => x.id === 'licenseNumberRequired')) {
          productItem.lineErrors.errors.push({
            id: 'licenseNumberRequired',
            error: this.adminConfigMessageList.find(x => x.configIDName === 'MsgRequireLicense').configIDValue
          });
        }
      } else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'licenseNumberRequired');
        const index = this.errorMsgs.findIndex(function (element) {
          return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
        });
        if (index !== -1) {
          this.errorMsgs.splice(index, 1);
        }
      }
    }

    // if ((!productItem.otherTreatment || productItem.otherTreatment.trim() === '') && productItem.replantTreatment == 'J1O') {
    //  if (!productItem.lineErrors.errors.find(x => x.id === 'otherTreatment')) {
    //    /* productItem.lineErrors.errors.push({ id: 'otherTreatment', error: 'Please enter the treatment name used.' });*/
    //    productItem.lineErrors.errors.push({ id: 'otherTreatment', error: this.adminConfigMessageList.find(x => x.configIDName == 'SoybeanTeatmentMsgFailure').configIDValue });
    //  }
    // }
    // else {
    //  productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'otherTreatment');
    //  let index = this.errorMsgs.findIndex(function (element) {
    //    return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
    //  });
    //  if (index !== -1) {
    //    this.errorMsgs.splice(index, 1);
    //  }
    // }

    if ((!productItem.replantTreatment || productItem.replantTreatment.trim() === '') && (productItem.treatment == 'JUT' && productItem.productLineId == '4J1')) {
      if (!productItem.lineErrors.errors.find(x => x.id === 'replantTreatment')) {
        productItem.lineErrors.errors.push({ id: 'replantTreatment', error: this.adminConfigMessageList.find(x => x.configIDName == 'SoybeanTeatmentMsgFailure').configIDValue });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'replantTreatment');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if ((!productItem.otherTreatment || productItem.otherTreatment.trim() === '') && productItem.replantTreatment == 'J1O') {
      if (!productItem.lineErrors.errors.find(x => x.id === 'otherTreatment')) {
        productItem.lineErrors.errors.push({ id: 'otherTreatment', error: 'Please enter Other Treatment' });
      }
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id !== 'otherTreatment');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }

    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }

    if (this.isTraverseAllFailedProductsForValidations && this.errorMsgs.length === 0 && !this.productItemsDataSource.data.find(x => x.lineErrors.errors.length > 0)) {
      this.isReview = false;
    }

    return productItem;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.itemId == this.nextErrorId && x.lotNumber == this.nextLotNumber) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) == -1) {
      this.index = 0;
    }
    this.nextErrorId = this.errorMsgs[this.index].itemId;
    this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
    this.currentErrorRow = this.index + 1;
    document.querySelector('#error_' + this.nextErrorId + '_' + this.nextLotNumber).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
    this.enableReviewRequesAndSaveOrderDraft();
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.checkBoxCount = 0;
    this.showTabs = false;
    this.isAllProductChecked = false;
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails(isApprover: number) {
    this.loaderService.setLoaderStatus(true);
    this.isSaveOrderDraftEnable = false;
    this.isReviewRequestEnable = false;
    this.subscription.add(this.seedCropLossService.getEditDetail(this.requestHeaderId, isApprover).subscribe((result: any) => {
      this.isEditMode = true;

      const rowId = 0;
      if (result.failedProductList && result.failedProductList.length > 0) {
        result.failedProductList.forEach(x => {
          x.rowId = rowId + 1;
          x.isSelected = false;
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
      }

      this.webOrderNumber = result.webOrderNumber;
      this.shipToAccount = result.shipToAccount;

      this.getGrowerListByAccount();

      this.seedCropLossService.setSelectedAccountNo(this.shipToAccount);
      this.shipToAccountList = [result.shipToAccountDetail];
      this.soldToAccountList = [result.soldToAccountDetail];
      this.soldToAccount = Number(result.shipToAccountDetail.soldTo);

      this.creditToAccount = result.creditToAccountNumber;
      this.creditToAnotherLocation = result.creditToAccountNumber ? true : false;
      this.growerGMK = result.gmk;

      this.originalProductItemsDataSource = [];
      this.productItemsDataSource = new MatTableDataSource(result.failedProductList);
      this.originalProductItemsDataSource = JSON.parse(JSON.stringify(result.failedProductList));

      this.productItemsDataSource.paginator = this.failedPaginator;
      this.productItemsDataSource.paginator.firstPage();

      this.disablecheckbox = false;

      this.checkBoxCount = 0;
      this.setBreadcrumbText();

      const forkJoinApis = [];
      const shipToAccountDetail = this.shipToAccountList.find(x => x.accountNumber === this.shipToAccount);
      this.shipToAccountName = shipToAccountDetail.accountName;
      forkJoinApis.push(this.seedCropLossService.getCreditToAccounts(shipToAccountDetail.accountNumber, shipToAccountDetail.parentNumber));
      forkJoinApis.push(this.seedCropLossService.getEffectiveConfigData());
      const licensePostData = {
        ItemNumber: result.failedProductList.map(x => x.itemNumber).join(','),
        Gmk: this.growerGMK
      };
      forkJoinApis.push(this.seedCropLossService.getItemsLicenseData(licensePostData));
      forkJoinApis.push(this.seedCropLossService.getItemsTreatmentData());
      this.subscription.add(forkJoin(forkJoinApis).subscribe((result: any[]) => {
        this.creditToList = result[0];
        this.effectiveConfigData = result[1];
        this.setLicenseDataIntoGridRows(result[2], this.productItemsDataSource.data);
        this.setLicenseDataIntoGridRows(result[2], this.originalProductItemsDataSource);
        this.treatmentList = result[3];
        this.loaderService.setLoaderStatus(false);
      }, error => this.loaderService.setLoaderStatus(false)));

      this.requestedBy = result.requestedBy;
      this.emailAddress = result.emailAddress;

      const parentNumber = this.shipToAccountList.find(x => x.accountNumber === this.shipToAccount).parentNumber;
      this.getUserList(parentNumber);

      this.isReviewRequestEnable = true;
      this.isSaveOrderDraftEnable = true;
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  setLicenseDataIntoGridRows(licenseData, gridData) {
    if (licenseData && gridData) {
      licenseData.forEach(x => {
        gridData.filter(y => y.itemNumber === x.itemNumber)
          .forEach(itemRow => {
            itemRow.vendorName = x.vendorName;
            if (itemRow.licenseManuallyEntered !== 2 || this.isGrowerChange) {
              if (x.licenseStatus === 'L') {
                itemRow.licenseNumber = x.licenseNumber;
                itemRow.licenseStatus = x.licenseStatus;
              } else {
                itemRow.licenseNumber = null;
                itemRow.licenseStatus = null;
              }
            }
          }
          );
      });
    }
  }

  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.originalProductItemsDataSource.length > 0 && this.productItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.originalProductItemsDataSource.filter(x => x.itemId === element.itemId)[0];
        oldLineValue.lineErrors = { 'itemId': oldLineValue.itemId, 'lotNumber': oldLineValue.lotNumber, 'errors': [] };;

        // get current object index
        const currentLineIndex = this.productItemsDataSource.data.findIndex(x => x.itemId === element.itemId);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.productItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.productItemsDataSource.data = this.productItemsDataSource.data;
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === oldLineValue.itemId;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }
          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.itemId);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.productItemsDataSource.data = JSON.parse(JSON.stringify(this.originalProductItemsDataSource));
        this.productItemsDataSource.data.forEach(x => {
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'errors': [] };
        });
        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.showTabs = false;
      this.isSaveOrderDraftEnable = true;
      this.isReviewRequestEnable = true;
    }
    this.enableReviewRequesAndSaveOrderDraft();
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true });
  }

  // Hide and show error line error
  showHideLineError(errorId: number) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString());
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  enableAllCheckBoxes(isChecked) {
    this.isAllProductChecked = isChecked;
    if (isChecked) {
      this.showTabs = true;
      this.productItemsDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.checkBoxCount = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true).length;
      const selectedItem = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true);
    }
    else {
      this.showTabs = false;
      this.productItemsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.showTabs = true;

      this.checkBoxCount = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.productItemsDataSource.filteredData.filter(x => x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllProductChecked = true;
      }
      else {
        this.isAllProductChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllProductChecked = false;
      const selected = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true);
      {
        if (selected && selected.length == 0) {
          this.showTabs = false;
        }
        else {
          this.showTabs = true;
        }
      }
    }
    const selectedItem = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true);
    if (selectedItem.length > 0) {
      this.showTabs = true;
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  setAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        this.tabNode = '';
        if (value) {
          this.isAllProductChecked = false;
          this.showTabs = false;
          const productAllList = this.productItemsDataSource.filteredData.filter(x => x.isSelected === true);

          if (productAllList.length == this.productItemsDataSource.data.length) {
            this.errorMsgs = [];
            this.productItemsDataSource = new MatTableDataSource([]);
            this.originalProductItemsDataSource = [];
          } else {
            productAllList.forEach(items => {
              let index = this.errorMsgs.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
              index = this.productItemsDataSource.data.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.productItemsDataSource.data.splice(index, 1);
              }

              index = this.originalProductItemsDataSource.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber;
              });
              if (index !== -1) {
                this.originalProductItemsDataSource.splice(index, 1);
              }
            });
          }

          this.productItemsDataSource.paginator = this.failedPaginator;
          this.productItemsDataSource.paginator.firstPage();

          this.checkBoxCount = 0;
          if (this.productItemsDataSource.data.length == 0) {
            this.disablecheckbox = true;
          }
        }

        this.enableReviewRequesAndSaveOrderDraft();
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
        break;
      default:
        break;
    }
  }

  hasInputTextChanged(productItem) {
    if (this.showErrorBlock) {
      productItem = this.validateFormEntries(productItem);
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { hasCropLossDataChange: true });
    this.enableReviewRequesAndSaveOrderDraft();
  }

  // set account table height
  setAccSummaryTableHeight() {
    const tableHeight = window.innerHeight - 85;
    $('.requestCOIOuter').css('height', tableHeight + 'px');
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  getEffectiveInvoiceDate(isFromDate: boolean, row: any): Date {
    let retVal = new Date();
    if (this.effectiveConfigData) {
      const productLineData = this.effectiveConfigData.find(x => x.productLineId === row.productLineId);
      if (productLineData) {
        if (isFromDate) {
          retVal = new Date(productLineData.invoiceEffectiveFromDate);
        }
        // else {
        //  if (new Date(productLineData.invoiceEffectiveToDate) <= new Date()) {
        //    retVal = new Date(productLineData.invoiceEffectiveToDate);
        //  }
        // }
      }
    }
    return retVal;
  }

  public IsShowTreatment(element: any): boolean {
    if (element.treatment == 'JUT' && element.productLineId == '4J1') { return true; }
    return false;
  }
}
